angular.module('NumbersEditor')
    .service('sportCodeService', ['SportCodeFactory', '$q', 'moment', function (sportCodeFactory, $q, moment) {
        function sportCodeService(sportCodeFactory, $q) {
            var self = this;
            self._sportCodeFactory = sportCodeFactory;
            self._$q = $q;
        };

        sportCodeService.prototype.getSportCodes = function () {
            var self = this;
            var deferred = self._$q.defer();
            self._sportCodeFactory.getAll()
                .success(function (sportCodes) {
                    deferred.resolve(sportCodes);
                })
                .error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        sportCodeService.prototype.getSportCode = function (sportCode) {
            var self = this;
            var deferred = self._$q.defer();
            self._sportCodeFactory.get(sportCode)
                .success(function (sportCodes) {
                    deferred.resolve(sportCodes);
                })
                .error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        return new sportCodeService(sportCodeFactory, $q);
    }]);